import { Button } from '@components/Button';
import MediaCard from '@components/Card/MediaCard';
import Block from '@components/Layout/Block';
import { getMediaCenterItems } from '@data/mediaCenter';
import { featuredMediaMentionMapping } from '@util/featuredMediaMentionMapping';
import { FC, ReactNode, useEffect, useState } from 'react';
import CardGridWithMobileCarousel from '..';
import {
  CarouselCtaWrapper,
  CarouselHeaderWrapper,
  CarouselHeadline,
  NoResultCard,
} from '../style';
import { useTranslations } from 'next-intl';

interface FeaturedMediaMentionsProps {
  header: string;
  mentions?: any[];
  locale: string;
}

const FeaturedMediaMentions: FC<FeaturedMediaMentionsProps> = ({ header, mentions, locale }) => {
  const t = useTranslations();
  const [mediaMentionArr, setMediaMentionArr] = useState<ReactNode[]>([]);

  const fetchAndSetBlogArr = async () => {
    try {
      const mediaMentionData = await getMediaCenterItems('mediaMentions', locale, 3);
      if (!mediaMentionData?.items || mediaMentionData?.items.length === 0) {
        return null;
      }
      const mappedBlogPosts = await featuredMediaMentionMapping(mediaMentionData?.items);
      setMediaMentionArr(renderCardElements(mappedBlogPosts));
    } catch (error) {
      console.log('FeaturedMediaMentions error', error);
    }
  };

  useEffect(() => {
    if (mentions && mentions.length > 0) {
      // if manually selected media mentions are passed in, use those
      const mappedBlogPosts = featuredMediaMentionMapping(mentions);
      setMediaMentionArr(renderCardElements(mappedBlogPosts));
    } else {
      // otherwise, fetch the newest 3 blog posts
      fetchAndSetBlogArr();
    }
  }, [mentions]);

  // function to map over cardArr and create array of ShopCard components
  const renderCardElements = (cardArr: any[]): ReactNode[] =>
    cardArr.map((card: any, ind: number) => {
      return (
        <>
          <MediaCard
            key={ind.toString()}
            publicationLogo={card.publicationLogo}
            alt_text={card.alt_text}
            title={card.title}
            publicationDate={card.publicationDate}
            description={card.description}
            url={card.url}
            locale={locale}
          />
        </>
      );
    });

  return (
    <Block>
      <CarouselHeaderWrapper>
        <CarouselHeadline>{header}</CarouselHeadline>
      </CarouselHeaderWrapper>
      {mediaMentionArr && mediaMentionArr.length > 0 ? (
        <CardGridWithMobileCarousel cardArr={mediaMentionArr} cardType="media" />
      ) : (
        <NoResultCard>{t('No News Articles Found')}</NoResultCard>
      )}

      <CarouselCtaWrapper>
        <Button
          url="/resources/media-center/media"
          label={t('View News Articles Press')}
          variant="secondary"
          arrow={false}
        />
      </CarouselCtaWrapper>
    </Block>
  );
};

export default FeaturedMediaMentions;
